import { useTranslation } from "react-i18next";

export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "it";

  const change = (lng) => {
    i18n.changeLanguage(lng);
    try { localStorage.setItem("mv_lang", lng); } catch (e) { /* localStorage unavailable (private mode); language will reset on reload */ }
  };

  return (
    <div className={`inline-flex items-center border border-zinc-200 rounded-sm overflow-hidden ${className}`} data-testid="language-switcher">
      <button
        type="button"
        onClick={() => change("it")}
        data-testid="lang-it"
        aria-label="Italiano"
        className={`px-2.5 py-1 text-xs font-bold uppercase tracking-wider transition-colors ${current === "it" ? "bg-[#FF5200] text-white" : "bg-white text-zinc-500 hover:text-[#09090B]"}`}
      >
        IT
      </button>
      <button
        type="button"
        onClick={() => change("en")}
        data-testid="lang-en"
        aria-label="English"
        className={`px-2.5 py-1 text-xs font-bold uppercase tracking-wider transition-colors ${current === "en" ? "bg-[#FF5200] text-white" : "bg-white text-zinc-500 hover:text-[#09090B]"}`}
      >
        EN
      </button>
    </div>
  );
}
